import { getMutations } from 'entities/_config';

import { apiCall, SuccessData } from 'services/api';

export const userMutations = getMutations({
  subscribeToEmails: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/preferences/emails/subscribe',
      });
    },
  },

  unsubscribeFromEmails: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/preferences/emails/unsubscribe',
      });
    },
  },

  closeAccount: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/security/close-account',
      });
    },
  },

  sendEmailConfirmation: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/users/email-confirmation/init',
      });
    },

    messages: {
      suppressError: true,
      suppressSuccess: true,
    },
  },

  confirmEmail: {
    action: async (payload: { code: string }): Promise<SuccessData> => {
      return apiCall({
        path: '/users/email-confirmation/complete',
        payload,
      });
    },

    messages: {
      suppressError: true,
      suppressSuccess: true,
    },
  },
});
